import { render } from "./Body.vue?vue&type=template&id=85a9c514&scoped=true"
import script from "./Body.vue?vue&type=script&lang=js"
export * from "./Body.vue?vue&type=script&lang=js"

import "./Body.vue?vue&type=style&index=0&id=85a9c514&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-85a9c514"

export default script